import React, {useState } from 'react'
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, Grid, Switch, TextField, Typography } from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { addAccountTypeApi, updateAccountTypeApi } from "../apiService";
import { checkApiStatus } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';


const AccountTypeCRU = ({ accountTypeCRU, modeType, getResponseBack, onToggleModal, params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [accountType, setAccountType] = useState(accountTypeCRU?.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const onFieldChange = (key, value) => {
        setAccountType((prev) => ({ ...prev, [key]: value }));
    };

    const onAddEditPartiesaccountType = () => {
        let validationInputs = {};
        validationInputs = {
            name: accountType?.name?.trim() ? "" : "Please enter Name",
            applicable_for: accountType?.applicable_for ? "" : "Please select Applicable for",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
          let payload = {
            ...accountType,
            status: accountType?.status ? true : false
          }
            if (accountType.id) {
                globalPutService(updateAccountTypeApi({ asset_slug: accountType?.slug }), payload)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit  Rate Account Type`, success_msg: response?.data?.message, item_id: accountType?.id, payload: payload, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Rate Account Type`, error_msg: response?.data?.message, item_id: accountType?.id, payload: payload, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addAccountTypeApi({ leaseSlug: params?.leaseSlug, }), payload).then((response) => {
                    if (checkApiStatus(response)) {
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Rate Account Type`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Rate Account Type`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Rate Account Type`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Rate Account Type`, page_type: page_type, })
    }
    return (
      <>
        <Dialog aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="md" fullWidth open={true} >
          <DialogTitle sx={{ m: 0, p: 2 }} className="dialog-header">
            <Typography sx={{ marginLeft: "10px" }}>
              {modeType === "add" ? "Add Rate Account Type" : modeType === "edit" ? "Edit Rate Account Type" : "View Rate Account Type"}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid size={{ md: 6, xs: 12 }}>
                <TextField
                  disabled={modeType === "view"}
                  id="name"
                  label="Name"
                  variant="outlined"
                  size="small"
                  required
                  margin="normal"
                  slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                  value={accountType?.name || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    if ( regexConstants.restrictUnicodeCharacters.test( val.trimStart(), ) || val === "" ) {
                        setAccountType((prev) => ({ ...prev, name: val }));
                        setError((prev) => ({ ...prev, name: "" }));
                      }
                  }}
                  onFocus={() => setError({ ...error, name: "" })}
                  error={Boolean(error?.name)}
                  helperText={ error?.name ||  "" }
                  fullWidth
                />
              </Grid>
              <Grid size={{ md: 6, sx: 12 }}>
                <Autocomplete
                  disableClearable
                  disabled={modeType === "view"}
                  options={[ { label: "Rental", value: 1 }, { label: "Reserve", value: 2 }, { label: "Both", value: 3 } ]}
                  getOptionLabel={(option) => option?.label || ""}
                  isOptionEqualToValue={(option,value)=>option?.value===value?.value}
                  size="small"
                  value={ accountType?.applicable_for || null}
                  onChange={(e, value) => onFieldChange("applicable_for", value)}
                  onFocus={() => setError({ ...error, applicable_for: "" })}
                  renderInput={(params) => ( <TextField {...params} label="Applicable for" size="small" margin="normal" required InputLabelProps={{ shrink: true }} helperText={error?.applicable_for || ""} error={Boolean(error?.applicable_for)} /> )}
                />
              </Grid>
              <Grid size={{ md: 12, xs: 12 }}>
                <FormGroup className="disabled-checkbox-wrapper">
                  <Box className="check-item-div" sx={{ cursor: modeType === "view" ? "not-allowed" : "pointer",marginLeft:'5px' }} >
                    <Typography className="check-item-span" fontSize="14px">
                      Status
                    </Typography>
                    <Switch checked={accountType?.status} onChange={(e) => onFieldChange("status", e.target.checked) } disabled={modeType === "view"} />
                    <span className="check-item-span" fontSize="14px">{accountType?.status === true ? 'Active' : 'Inactive'}</span>
                  </Box>
                </FormGroup>
              </Grid>
              {modeType === "view" ? (
                <Grid item size={{ md: 12, xs: 12 }}>
                  <LessMoreTextFieldComp label="Remarks" value={accountType?.remarks || ""} />
                </Grid>
              ) : (
                <Grid size={{ md: 12, xs: 12 }}>
                  <TextField
                    disabled={modeType === "view"}
                    id="remarks"
                    label="Remarks"
                    variant="outlined"
                    size="small"
                    margin="normal"
                    slotProps={{ inputLabel: { shrink: true } }}
                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                    value={accountType?.remarks || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      setAccountType((prev) => ({ ...prev, remarks: val }));
                      setError((prev) => ({ ...prev, remarks: "" }));
                    }}
                    fullWidth
                    multiline
                    rows={3}
                  />
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ marginRight: "15px" }}>
            <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked("Cancel Button"); }} >
              {modeType === "view" ? "Close" : "Cancel"}
            </Button>
            {modeType === "view" ? null : (
              <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked("Save Button"); onAddEditPartiesaccountType(); }} >
                {isLoading ? ( <CircularProgress size={24} color="inherit" /> ) : ( "SAVE" )}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </>
    );
}

export default AccountTypeCRU